import { List, Map } from 'immutable';
import {
  records as jobsRecords,
  types as jobsTypes,
} from '@saucelabs/sl-module-jobs';

import { types as filterTypes } from '../filters';
import * as types from './types';

const initialState = Map({
  headlessAutomated: List(),
  headlessAutomatedLoading: true,
});

const jobsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case jobsTypes.AUTOMATED_JOBS_GET.FAILURE:
      return state.set('headlessAutomatedLoading', false);
    case jobsTypes.JOBS_GET.SUCCESS:
    case jobsTypes.AUTOMATED_JOBS_GET.SUCCESS: {
      const jobs = payload.jobs.map((job) => new jobsRecords.JobRecord(job));
      return state.withMutations((mutable) => (
        mutable
          .set('headlessAutomated', List(jobs))
          .set('headlessAutomatedLoading', false)
      ));
    }
    case filterTypes.TOGGLE_STATUS:
    case filterTypes.SELECT_OWNER:
    case filterTypes.CLEAR_OWNER:
    case filterTypes.CLEAR_STATUSES:
      return state.set('headlessAutomatedLoading', true);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default jobsReducer;
